import type { M3pProjection } from "@dearbill/shared";

/** Body copy for a cost card whose estimate is unavailable. */
export const ESTIMATE_PENDING_COPY =
  "We're still working out your estimate — check back after your form is approved.";

/**
 * The copy under an unavailable figure. A next-year block whose assigned plan
 * has no next-year snapshot (the server prices it `plan_unknown` with
 * `pricesEstimated`) says the plan is not offered that year; every other
 * unavailable estimate is still pending.
 */
export function unavailableCopy(m3p: M3pProjection | null): string {
  if (m3p?.pricesEstimated && m3p.unavailableReason === "plan_unknown" && m3p.contractYear !== null)
    return `Your plan isn't offered in ${m3p.contractYear}.`;
  return ESTIMATE_PENDING_COPY;
}
